import React, { cloneElement, useState } from 'react'
import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react'
import { isEmpty } from 'lodash'

import { Button } from '@/components/buttons/Button'

import './MultiStepForm.scss'

const MultiStepForm = ({ modalClose, steps, stepLabels = [], navigatable = false }) => {
  const [activeStep, setActiveStep] = useState(0)

  const slidePanel = (nextStep, stepsLength) =>
    setActiveStep(((nextStep % stepsLength) + stepsLength) % stepsLength)

  const nextPanel = () => slidePanel(activeStep + 1, steps.length)
  const prevPanel = () => slidePanel(activeStep - 1, steps.length)

  const currentSlide = cloneElement(steps[activeStep], {
    modalClose,
    nextPanel,
  })

  const hasStepLabels = !isEmpty(stepLabels)

  return (
    <div className="multi-step-form" data-testid="multi-step-form">
      {hasStepLabels && (
        <div className="multi-step-form__indicator" data-testid="step-indicator">
          <span className="multi-step-form__step-count">
            {`Step ${activeStep + 1} of ${steps.length}`}
          </span>
          {stepLabels[activeStep] && (
            <>
              <span className="multi-step-form__dot">·</span>
              <span className="multi-step-form__step-label">{stepLabels[activeStep]}</span>
            </>
          )}
        </div>
      )}
      <div className="multi-step-form__body">
        {navigatable && activeStep !== 0 && (
          <Button
            basic
            square
            icon={<IconChevronLeft />}
            className="multi-step-form__nav multi-step-form__nav--prev"
            onClick={prevPanel}
            aria-label="Previous step"
          />
        )}
        <div className="multi-step-form__content">{currentSlide}</div>
        {navigatable && activeStep !== steps.length - 1 && (
          <Button
            basic
            square
            icon={<IconChevronRight />}
            className="multi-step-form__nav multi-step-form__nav--next"
            onClick={nextPanel}
            aria-label="Next step"
          />
        )}
      </div>
    </div>
  )
}

export default MultiStepForm
